import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api, { API_ENDPOINTS } from '../config/api';
import BlogPreviewColumns from '../components/BlogPreviewColumns';
import BlogCardOverflow from '../components/BlogCardOverflow';
import { Loader2, ChevronLeft, ChevronRight } from 'lucide-react';

const TrendingPage = () => {
  const [page, setPage] = useState(1);
  const limit = 21;

  const { data, isLoading } = useQuery({
    queryKey: ['blogs', 'trending', page],
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.BLOGS.LIST, {
        params: { filter: 'trending', page, limit },
      });
      return response.data;
    },
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-accent" />
      </div>
    );
  }

  const blogs = data?.blogs || [];
  const pagination = data?.pagination || {};
  const totalPages = Math.ceil((pagination.total || blogs.length) / limit);

  // First 12 cards with overflow
  const firstRow = blogs.slice(0, 12);
  // Next 9 cards for 3 columns
  const columnsData = blogs.slice(12, 21);

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-4xl font-heading font-bold text-heading dark:text-white mb-8">
          Trending Now
        </h1>

        {/* First Row: 12 cards with overflow */}
        {firstRow.length > 0 && (
          <div className="mb-12">
            <BlogCardOverflow blogs={firstRow} showCount={3} />
          </div>
        )}

        {/* Second Row: 3 columns with 9 preview cards */}
        {columnsData.length > 0 && (
          <div className="mb-12">
            <BlogPreviewColumns blogs={columnsData} />
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center space-x-2 mt-12">
            <button
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center"
            >
              <ChevronLeft className="w-4 h-4 mr-1" />
              Previous
            </button>
            <span className="px-4 py-2">
              Page {page} of {totalPages}
            </span>
            <button
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center"
            >
              Next
              <ChevronRight className="w-4 h-4 ml-1" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrendingPage;
